import styled from 'styled-components';
import { FeedbackSidebarSection } from '../../FeedbackSidebarSection/FeedbackSidebarSection';

export const Container = styled.div`
  width: 100%;
`;

export const StyledFeedbackSidebarSection = styled(FeedbackSidebarSection)`
  margin-bottom: 32px;
  width: 100%;
`;
